/*level,minzoom,maxzoom配置必须是数字*/
let xiazuanConfig = {
  defaultBorderColor: "#00FFFF",/*默认的高亮边框颜色*/
  defaultBorderWidth: 4,/*默认的高亮边框宽度*/
  defaultBorderOpacity: 1,/*默认的高亮边框透明度*/
  defaultOverFillColor: "#0127EB",/*默认下钻鼠标悬浮高亮颜色*/
  defaultOverFillOpacity: 0.2,/*默认下钻鼠标悬浮高亮透明度*/

  qgConfig: {/*全国级别配置,此配置单独在此处*/
    "levelName": "全国",
    "level": 0,
    "layerId": "国界线",
    "sourceId": "gj",
    "sourceLayer": "gj",
    "qhmc_props": "XZQMC",
    "qhdm_props": "XZQDM",
    "ptLayerId": "中国",
    "sourceId_pt": "dt_gj_pt",
    "sourceLayer_pt": "dt_gj_pt",
    "borderColor": "",
    "borderWidth": "",
    "borderOpacity": "",
    "overFillColor": "",
    "overFillOpacity": "",
    "minzoom": 0,
    "maxzoom": 4,
    "layer_fill": "dt_gj_fill",
    "layer_bk": "dt_gj_bk"
  },
  xzqLayer: [
    {
      "levelName": "省",
      "level": 1,
      "layerId": "省级",
      "sourceId": "dt_sy_hunan",
      "sourceLayer": "dt_sy_hunan",
      "qhmc_props": "qhmc",
      "qhdm_props": "qhdm",
      "ptLayerId": "省级-点",
      "sourceId_pt": "dt_sy_pt_hunan",
      "sourceLayer_pt": "dt_sy_pt_hunan",
      "borderColor": "",
      "borderWidth": "",
      "borderOpacity": "",
      "overFillColor": "",
      "overFillOpacity": "",
      "minzoom": 2,
      "maxzoom": 5,/*把省写低一个级别，正常是7，为了省域的下钻图层和地市域的下钻图层不重叠*/
      "layer_fill": "dt_sy_fill",
      "layer_bk": "dt_sy_bk",
      "additionalLayers": [],/*点击下钻后,其他也想按下级行政区同等条件过滤的图层ID数组)*/
    },
    {
      "levelName": "地市",
      "level": 2,
      "layerId": "地市级",
      "sourceId": "dt_dsy_hunan",
      "sourceLayer": "dt_dsy_hunan",
      "qhmc_props": "qhmc",
      "qhdm_props": "qhdm",
      "ptLayerId": "地市级-点",
      "sourceId_pt": "dt_dsy_pt_hunan",
      "sourceLayer_pt": "dt_dsy_pt_hunan",
      "borderColor": "",
      "borderWidth": "",
      "borderOpacity": "",
      "overFillColor": "",
      "overFillOpacity": "",
      "minzoom": 5,
      "maxzoom": 7,
      "layer_fill": "dt_dsy_fill",
      "layer_bk": "dt_dsy_bk",
      "additionalLayers": [],/*点击下钻后,其他也想按下级行政区同等条件过滤的图层ID数组)*/
    },
    {
      "levelName": "县",
      "level": 3,
      "layerId": "县级",
      "sourceId": "dt_xy_hunan",
      "sourceLayer": "dt_xy_hunan",
      "qhmc_props": "qhmc",
      "qhdm_props": "qhdm",
      "ptLayerId": "县级-点",
      "sourceId_pt": "dy_xy_pt_hunan",
      "sourceLayer_pt": "dy_xy_pt_hunan",
      "borderColor": "",
      "borderWidth": "",
      "borderOpacity": "",
      "overFillColor": "",
      "overFillOpacity": "",
      "minzoom": 7,
      "maxzoom": 9,
      "layer_fill": "dt_xy_fill",
      "layer_bk": "dt_xy_bk",
      "additionalLayers": [],/*点击下钻后,其他也想按下级行政区同等条件过滤的图层ID数组)*/
    },
    {
      "levelName": "乡镇",
      "level": 4,
      "layerId": "乡镇级",
      "sourceId": "dt_xzy_hunan",
      "sourceLayer": "dt_xzy_hunan",
      "qhmc_props": "qhmc",
      "qhdm_props": "qhdm",
      "ptLayerId": "乡镇级-点",
      "sourceId_pt": "dt_xzy_pt_hunan",
      "sourceLayer_pt": "dt_xzy_pt_hunan",
      "borderColor": "",
      "borderWidth": "",
      "borderOpacity": "",
      "overFillColor": "",
      "overFillOpacity": "",
      "minzoom": 9,
      "maxzoom": 11.3,
      "layer_fill": "dt_xzy_fill",
      "layer_bk": "dt_xzy_bk",
      "additionalLayers": [],/*点击下钻后,其他也想按下级行政区同等条件过滤的图层ID数组)*/
    },
    {
      "levelName": "村",
      "level": 5,
      "layerId": "村级",
      "sourceId": "dt_cy_hunan",
      "sourceLayer": "dt_cy_hunan",
      "qhmc_props": "qhmc",
      "qhdm_props": "qhdm",
      "ptLayerId": "村级-点",
      "sourceId_pt": "dt_cy_pt_hunan",
      "sourceLayer_pt": "dt_cy_pt_hunan",
      "borderColor": "",
      "borderWidth": "",
      "borderOpacity": "",
      "overFillColor": "",
      "overFillOpacity": "",
      "minzoom": 11,
      "maxzoom": 17,    //原来是18  为了兼容首页的村级摄像头点击事件误命中下钻  故把等级调低，如需调整，三思。。。
      "layer_fill": "dt_cy_fill",
      "layer_bk": "dt_cy_bk",
      "additionalLayers": [],/*点击下钻后,其他也想按下级行政区同等条件过滤的图层ID数组)*/
    },
  ]
};
export default xiazuanConfig;



// WEBPACK FOOTER //
// ./src/assets/js/drillDown/drillDownConfig.js